module.exports = __webpack_public_path__ + "static/media/developer-magento-extension-partner-770x600.136c5216.jpg";